
export type EInvoiceType = typeof EInvoiceType[keyof typeof EInvoiceType];


export const EInvoiceType = {
  Pdf: 'Pdf',
  EInvoice: 'EInvoice',
} as const;
